import { 
  doc, 
  setDoc, 
  getDoc, 
  updateDoc,
  arrayUnion,
  arrayRemove } from 'firebase/firestore';
import { auth, db } from '../../firebase.config';

const normalizeWishlistItem = (item) => {
  if (typeof item === 'number') {
    return { countryId: item, priority: null };
  }
  if (typeof item === 'object' && item.countryId !== undefined) {
    return { countryId: item.countryId, priority: item.priority || null };
  }
  return item;
};

export const saveWishlistToFirestore = async (userId, wishlist) => {
  try {
    const userDocRef = doc(db, 'wishlists', userId);
    const normalizedWishlist = wishlist.map(e => normalizeWishlistItem(e));
    await setDoc(userDocRef, {
      wishlist: normalizedWishlist,
      userName: auth.currentUser?.displayName || 'Traveler',
      lastUpdated: new Date()
    });
  } catch (err) {
    console.error('Error saving wishlist:', err);
  }
};

export const loadWishlistFromFirestore = async (userId) => {
  try {
    const userDocRef = doc(db, 'wishlists', userId);
    const docSnap = await getDoc(userDocRef);
    
    if (docSnap.exists()) {
      let wishlist = docSnap.data().wishlist || [];
      if (wishlist.length > 0 && typeof wishlist[0] === 'number') {
        wishlist = wishlist.map(e => ({ countryId: e, priority: null }));
        await setDoc(userDocRef, {
          wishlist: wishlist,
          userName: docSnap.data().userName || 'Traveler',
          lastUpdated: new Date()
        }, { merge: true });
      }
      return wishlist;
    } else {
      return [];
    }
  } catch (err) {
    console.error('Error loading wishlist:', err);
    return [];
  }
};

export const addCountryToWishlist = async (userId, countryCode) => {
  const userDocRef = doc(db, 'wishlists', userId);
  const newItem = { countryId: countryCode, priority: null };
  
  try {
    await updateDoc(userDocRef, {
      wishlist: arrayUnion(newItem),
      userName: auth.currentUser?.displayName || 'Traveler',
      lastUpdated: new Date()
    });
  } catch (err) {
    if (err.code === 'not-found') {
      await setDoc(userDocRef, {
        wishlist: [newItem],
        userName: auth.currentUser?.displayName || 'Traveler',
        lastUpdated: new Date()
      });
    } else {
      console.error('Error adding country to wishlist:', err);
    }
  }
};

export const removeCountryFromWishlist = async (userId, countryCode) => {
  try {
    const userDocRef = doc(db, 'wishlists', userId);
    const docSnap = await getDoc(userDocRef);
    
    if (docSnap.exists()) {
      const currentWishlist = docSnap.data().wishlist || [];
      const itemToRemove = currentWishlist.find(e => 
        (typeof e === 'number' ? e : e.countryId) === countryCode
      );
      
      if (itemToRemove) {
        await updateDoc(userDocRef, {
          wishlist: arrayRemove(itemToRemove),
          userName: auth.currentUser?.displayName || 'Traveler',
          lastUpdated: new Date()
        });
      }
    }
  } catch (err) {
    console.error('Error removing country from wishlist:', err);
  }
};

export const updatePriorityInFirestore = async (userId, countryCode, priority) => {
  try {
    const userDocRef = doc(db, 'wishlists', userId);
    const docSnap = await getDoc(userDocRef);
    
    if (docSnap.exists()) {
      const currentWishlist = docSnap.data().wishlist || [];
      const updatedWishlist = currentWishlist.map(e => {
        const id = typeof e === 'number' ? e : e.countryId;
        if (id === countryCode) {
          return { countryId: id, priority: priority };
        }
        if (typeof e === 'number') {
          return { countryId: e, priority: null };
        }
        return e;
      });
      
      await setDoc(userDocRef, {
        wishlist: updatedWishlist,
        userName: auth.currentUser?.displayName || 'Traveler',
        lastUpdated: new Date()
      }, { merge: true });
    }
  } catch (err) {
    console.error('Error updating priority:', err);
  }
};